import React from 'react';

import { StyledSingleActionButton } from './connect-provider.styled';
import { ConnectProviderStatus } from './enums';
import { MultipleActions } from './MultipleActions';
import { ProviderAnalyticLiteralIds } from './types';

export interface ConnectProviderActionsProps {
  analyticIds: ProviderAnalyticLiteralIds;
  close: () => void;
  connectProvider: () => void;
  providerName: string;
  restart: () => void;
  status: ConnectProviderStatus;
}

export const ConnectProviderActions = ({
  analyticIds,
  close,
  connectProvider,
  providerName,
  restart,
  status,
}: ConnectProviderActionsProps): React.ReactElement | null => {
  switch (status) {
    case ConnectProviderStatus.SUCCESS: {
      return (
        <StyledSingleActionButton variant="primary" rounded="regular" size="base" onClick={close}>
          Close
        </StyledSingleActionButton>
      );
    }
    case ConnectProviderStatus.ERROR: {
      return (
        <MultipleActions
          actions={[
            {
              button: {
                variant: 'white',
                rounded: 'regular',
                size: 'base',
                onClick: close,
                children: 'Close',
                id: analyticIds.cancelConnectionId,
              },
            },
            {
              button: {
                variant: 'action',
                rounded: 'regular',
                size: 'base',
                onClick: connectProvider,
                children: 'Try Again',
                id: 'try-again-btn',
              },
            },
          ]}
        />
      );
    }
    case ConnectProviderStatus.NOT_STARTED:
    case ConnectProviderStatus.WAITING_TOKEN:
      return (
        <MultipleActions
          actions={[
            {
              button: {
                variant: 'white',
                rounded: 'regular',
                size: 'base',
                onClick: restart,
                children: 'Cancel and Go Back',
                id: analyticIds.cancelConnectionId,
              },
              actionText: 'If you no longer wish to continue',
            },
            {
              button: {
                variant: 'primary',
                rounded: 'regular',
                size: 'base',
                onClick: connectProvider,
                children:
                  status === ConnectProviderStatus.WAITING_TOKEN ? `Reopen ${providerName}` : `Open ${providerName}`,
                id: analyticIds.connectId,
              },
              actionText:
                status === ConnectProviderStatus.WAITING_TOKEN ? 'Waiting for token' : 'If you closed the window',
            },
          ]}
        />
      );
    default:
      return null;
  }
};
